export const transitions = {
    linear: '0.15s linear',
    linearFast: '0.1s linear',
};
